import Config from "../../../../../shared/src/ranj/app/config/Config";

export default class GameConfig extends Config {

    constructor() {
        super();
    }

    get puzzles() {
        return this.getValue(`puzzles`);
    }
    
    get practicePuzzles() {
        return this.getValue(`practicePuzzles`);
    }

    getPracticePuzzle(idx, wrap = true) {
        if (wrap) {
            idx = idx % this.practicePuzzles.length
        }
        return this.practicePuzzles[idx];
    }

    getPuzzle(idx, wrap = true) {
        if (wrap) {
            idx = idx % this.puzzles.length
        }
        return this.puzzles[idx];
    }

    get time() {
        return this.getValue(`time`);
    }

    getLocation(index) {
        return this.getValue(`locations`)[index];
    }

    getLocationSkin(index) {
        return this.getLocation(index).skin;
    }

    getItemName(index) {
        return this.getValue(`items`)[index];
    }

}